
/**
 * 西班牙语（es）
 */

export default {
  // 支付
  common: {
    default: 'Defecto',
    delete: 'Borrar',
    cancel: 'Cancelar',
    submit: 'Enviar',
    inputContent: 'Contenido de entrada',
    selectContent: 'Seleccionar contenido',
    pleaseEnter: 'Por favor escribe',
    confirm: 'confirmar',
    Warning: 'Advertencia',
    success: 'Éxito',
    next: 'Siguiente'
  },
  payment: {
    payment: 'Pago',
    availableBalance: 'Saldo disponible',
    topUp: 'Completar',
    creditCard: 'Tarjeta de crédito',
    settings: 'ajustes',
    transactions: 'Actas',
    paymentMethods: 'Métodos de pago',
    type: 'Escribe',
    orderNumber: 'Número de orden',
    amount: 'Monto',
    transactionTime: 'Tiempo de transacción',
    allType: 'Todo tipo',
    expenditure: 'Gasto',
    income: 'Ingreso',
    balance: 'Equilibrio',
    refund: 'Reembolso',
    sample: 'Muestra',
    purchase: 'Compra',
    orderGoods: 'Mercancías de la orden',
    cardNo: 'Tarjeta No',
    expireDate: 'Fecha de caducidad',
    addCard: 'Agregar tarjeta',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha final',
    export: 'Exportar',
    enterAmount: 'envío directo',
    dropshipping: 'Dropshipping',
    recharge: 'recargar',
    orderDeposit: 'depósito de la orden',
    orderBalance: 'saldo de la orden',
    systemTopup: 'Sistema completo',
    giftCard: 'Tarjeta de regalo'
  },
  // 地址
  address: {
    address: 'Dirección',
    editTheAddress: 'Editar la dirección',
    setAsDefault: 'Establecer por defecto',
    addAddress: 'Añadir dirección',
    fullName: 'Nombre completo',
    phoneNumber: 'Número de teléfono',
    streetAddressLine1: 'Dirección Calle 1',
    streetAddressLine2: 'Dirección Calle 2',
    city: 'Ciudad',
    state: 'Estado',
    provice: 'Provice',
    region: 'Región',
    country: 'País',
    countryRegion: 'País/Región',
    zipCode: 'Código postal',
    vat: 'IVA',
    setAsDefaultAddress: 'Establecer como dirección predeterminada',
    defaultAddress: 'dirección predeterminada',
    stateProviceRegion: 'Estado/Provice/Región',
    deleteTip: '¿Estás seguro de eliminar esta dirección?'
  },
  // 店铺
  store: {
    store: 'Tienda',
    stores: 'Tienda',
    allStores: 'Todas las tiendas',
    storeTips: 'Una vez que se agrega su tienda, puede publicar decenas de miles de artículos de moda en su tienda con solo unos pocos clics. KakaClo se encargará de todo lo demás después de que se realice un pedido en su tienda.',
    allowStoreBinding: 'Permitir vinculación de tienda',
    connectANewStore: 'Conectar una tienda nueva',
    authorized: 'Autorizado',
    unauthorized: 'No autorizado',
    reauthorize: 'Reautorizar',
    storeSettings: 'Configuración de la tienda',
    removeStoreTitle: '¿Estás seguro de que quieres eliminar esta tienda??',
    removeStoreTips: 'Si solo desea dejar de sincronizar los datos de la tienda con nuestra plataforma y mantener la configuración de su tienda, puede desactivar la tienda en lugar de eliminarla..',
    removeStoreTips1: 'Después de que se elimine la tienda, los siguientes datos asociados con la tienda también se eliminarán y no se podrán recuperar:',
    listings: 'Listings',
    OrdersOfstore: 'Pedidos de la tienda.',
    removeTheStore: 'Quitar tienda',
    storeUrl: 'URL de la tienda',
    openStoreMsg: 'Felicitaciones activación, obtendrá el pedido de su tienda vinculada!',
    closeStoreAlert: '¿Estás seguro de que quieres desactivar la tienda?',
    closeStoreTips: 'No podrá recibir pedidos después de que la tienda esté desactivada',
    closeStoreMsg: 'Has cerrado tu tienda, puedes reabrir la tienda para recibir pedidos.',
    chooseStoreTip: 'Elige la plataforma de tu tienda',
    addStoreTip: 'SOLO entrar',
    addStoreTip2: 'tu dominio predeterminado',
    shopifyTips: 'Inicie sesión en su administrador de Shopify para encontrar su dominio predeterminado.',
    shopifyTips1: 'ввв.Уур-Дефаулт-Доман.мишопифи.цум',
    shoplazzaTips: 'Inicie sesión en su administrador de Shoplazza para encontrar su dominio predeterminado.',
    shoplazzaTips1: 'www.Su-dominio-predeterminado.shoplazza.com',
    shoplineTips: 'Inicie sesión en su administrador de Shopline para encontrar su dominio predeterminado.',
    shoplineTips1: 'www.Su-dominio-predeterminado.shopline.com',
    eg: 'p.ej. ',
    addStoreVideoTip: 'Cómo conectar una nueva tienda'
  },
  // 店铺设置
  storeSetting: {
    storeStting: 'Configuración de la tienda',
    storeName: 'Nombre de la tienda',
    whetherToAuthorize: 'Ya sea para autorizar',
    storeLink: 'Enlace de tienda',
    taxRuleTitle: 'Hacer que el producto esté sujeto a impuestos',
    taxRuleTip: 'Especifica si se cobrará un impuesto o no cuando se venda la variante del producto..',
    productNationalRules: 'Normas nacionales',
    productNationalRulesTip: 'Cuando los productos recién lanzados llegan a la tienda, el país de recepción por defecto es',
    productRules: 'Reglas de producto',
    productRuleTip: 'Elija una acción cuando cambie el inventario del artículo conectado a su sku de tienda..',
    productRuleTip1: 'Cuando un proyecto no está disponible en kakaclo:',
    dontDealWidth: 'No lidies con',
    dontDealWidth1: 'Establecer el monto de inventario de un material específico en 0.',
    productRuleY: 'Actualizar el inventario de SKU de la tienda automáticamente',
    productRuleY1: 'Archivo o eliminación',
    productRuleYHint1: 'si el artículo es un spu (unidad de inventario) no disponible, se archiva el artículo; si el artículo es un SKU (unidad de inventario) no disponible, se elimina el artículo.',
    productRuleYHint2: 'Al establecer el monto del inventario en 0, significa que el material está agotado o no se puede comprar. Esto ayuda a gestionar con precisión su inventario y evita que los clientes ordenen productos que actualmente no están disponibles.',
    productRuleYHint3: 'Archivar un proyecto significa que se eliminará temporalmente de la lista de actividades, pero si el proyecto está disponible de nuevo, puede recuperarse en el futuro. Por otro lado, eliminar un elemento significa que se eliminará permanentemente de su lista y no se puede recuperar.',
    productRuleYHint4: 'Solo tiene efecto cuando el nombre del método de envío establecido por su tienda es consistente con KakaClo. Si es inconsistente, el sistema usa Express de forma predeterminada; los nombres de los métodos de envío admitidos por KakaClo: 1. Estándar; 2. Expreso; 3. Acelerado',
    productRuleYHint5: 'Cuando la información del producto kakaclo cambie y obtenga la información más reciente de kakaclo, actualice la siguiente información:',
    priceRules: 'Reglas de precios',
    changeField1: 'Titulo del producto',
    changeField2: 'Descripción',
    changeField3: 'Carta del tamaño',
    changeField4: 'Variantes',
    changeField5: 'Imágenes',
    storeCurrency: 'moneda',
    compareAtPrice: 'Comparar a precio',
    price: 'Precio',
    originalPrice: 'Precio sugerido',
    multiplier: 'Multiplicador',
    shipping: 'Costo de envío',
    orderRules: 'Reglas de pedido',
    orderRulesTip1: 'Cuando el proveedor de entrega de pedidos de la tienda entregue los productos, seleccione una acción.',
    orderRulesY: 'Cargue automáticamente el número de pedido de logística en la tienda',
    orderRulesTip2: 'Cuando su tienda recibe un nuevo pedido, ya sea que realice el pedido automáticamente.',
    orderRulesTip2N: 'No comprado automáticamente',
    orderRulesTip2Y: 'Compra automáticamente',
    save: 'Guardar ajustes',
    selectCurrency: 'Elige moneda',
    productCost: 'Costo del producto',
    orderRulesYTip: 'Antes de usar esta regla, visite shopify para configurar el envío automático'

  },

  // 注册身份
  signupUser: {
    questionTile: '¿Cómo te describirías en el negocio de la moda?',
    answer1: 'Soy vendedor en linea',
    answer2: 'Soy un vendedor de ladrillo y mortero.',
    answer3: 'Soy vendedor omnicanal',
    answer4: 'soy un influenciador',
    answer5: 'soy un cliente',
    answer6: 'Otro'
  },
  // my information
  myInformation: {
    myInformation: 'Mi informacion'
  }
}
